import { Button, Input, Modal } from "antd";
import { useEffect } from "react";
import { roleNames,roleIds } from "../../constant";
const QAModel = ({
  open,
  mode,
  handleCancel,
  formData,
  handleInputChange,
  handleSubmit,
  handleStatusChange,
  selectedRole,
  setSelectedRole,
  roles,
  selectedZone,
  setSelectedZone,
  zones,
  setSelectedQaLead,
  selectedQaLead,
  tempQaLeads,
  loggedInUserId,
  loggedInRole,
  loggedInZoneId
}) => {

  const isQualityLeadLoggedIn = loggedInRole === roleNames.qualityLead;
  const isTrainerLoggedIn = loggedInRole === roleNames.trainer;
  const isTraineeSelected = selectedRole === roleIds.trainee;

  //SUPER_ADMIN,ADMIN ,OPS_TEAM_LEAD,TRAINING_LEAD
   const ROLES_WITHOUT_ZONE = [1, 3, 6,5,9]; 
  //  OPS_LEAD, Quality lead, Trainner (example IDs)
  const ROLES_WITH_ZONE_ONLY = [4, 5, 7,8]; 
  // QA, Trainee,
  const ROLES_WITH_ZONE_AND_LEAD = [2, 10]; 
    // QA, TRAINER
  const isReadyForUserForm = (() => {
    if (!selectedRole) return false;
    // Role does not need zone
    if (ROLES_WITHOUT_ZONE.includes(selectedRole)) {
      return true;
    }
    // Role needs zone only
    if (ROLES_WITH_ZONE_ONLY.includes(selectedRole)) {
      return !!selectedZone;
    }
    // Role needs zone + lead
    if (ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole)) {
      return !!selectedZone && !!selectedQaLead;
    }
    return false;
  })();


    useEffect(() => {
      if (
        open &&  mode === "edit" &&
        formData && roles?.length &&  zones?.length
      ) {

      setSelectedRole(Number(formData.role_id));
      setSelectedZone(formData.zone != null ? Number(formData.zone) : null);
      }
    }, [open, mode, formData, roles, zones]);

    useEffect(() => {
      if (
        open &&  mode === "edit" &&
        ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole) &&
        selectedZone &&  tempQaLeads?.length &&
        formData?.qa_lead_id
      ) {
        const leadId = Number(formData.qa_lead_id);
        setSelectedQaLead(leadId);
      }
    }, [open, mode, selectedRole, selectedZone, tempQaLeads, formData]);

    useEffect(() => {
      // For Quality Lead or Trainer when adding a new user
      if (
        open &&
        mode !== "edit" &&
        (isQualityLeadLoggedIn || isTrainerLoggedIn) &&
        ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole)
      ) {
        // auto-select zone
        if (!selectedZone && loggedInZoneId) {
          const zoneId = Number(loggedInZoneId);
          setSelectedZone(zoneId);
          handleInputChange({
            target: { name: "zone_id", value: zoneId },
          });
        }

        // auto-select QA lead or Trainer themselves
        if (!selectedQaLead && loggedInUserId) {
          const userId = Number(loggedInUserId);
          setSelectedQaLead(userId);
          handleInputChange({
            target: {
              name: ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole) && isTrainerLoggedIn 
                ? "trainer_id" // optional if you want to store as "trainer_id"
                : "qa_lead_id", 
              value: userId,
            },
          });
        }
      }
    }, [
      open,
      mode,
      selectedRole,
      isQualityLeadLoggedIn,
      isTrainerLoggedIn,
      loggedInZoneId,
      loggedInUserId,
      selectedZone,
      selectedQaLead
    ]);

  const isEdit = mode === "edit";
  return (
    <>
      <Modal
        title={
          isEdit ? (
            <div className="container-fluid d-flex flex-column align-items-center text-center">
              <div className="d-flex justify-content-start flex-column w-100 mb-2">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50px",
                    background: "#052659",
                    color: "#FFFFFF",
                  }}
                >
                  <i className="bi bi-people icon"></i>
                </div>
                <div className="d-flex justify-content-start mt-3">
                  <span className="fs-5 fw-semibold">Edit Users</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center text-center">
              <div className="d-flex justify-content-between w-100 mb-2">
                <span className="fs-5 fw-semibold">Adding a new User</span>
              </div>
            </div>
          )
        }
        open={open}
        onCancel={handleCancel}
        width={750}
        footer={null}
      >
        <div className="container-fluid">
          <form className="row g-3 text-start" onSubmit={handleSubmit}>
            {/* Step 1: Role Selection */}
             <div className="col-md-12 mb-3">
                <label>
                  Select Role<span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  value={selectedRole || ""}
                  onChange={(e) => {
                    const roleId = Number(e.target.value);
                    setSelectedRole(roleId);
                    handleInputChange({ target: { name: "role_id", value: roleId } });

                    // reset dependent fields
                    if (!isQualityLeadLoggedIn && !isTrainerLoggedIn) {
                    setSelectedZone(null);
                    setSelectedQaLead(null);
                  }
                  }}
                  required
                >
                  <option value="" disabled>Select Role</option>
                  {roles.map(role => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
              {/*step 3 Show ZONE only when required */}
              {selectedRole && !ROLES_WITHOUT_ZONE.includes(selectedRole) && (
                <div className="col-md-12 mb-3">
                  <label>
                    Select Zone<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={selectedZone || ""}
                    disabled={
                       (isQualityLeadLoggedIn || isTrainerLoggedIn)&&
                      ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole)
                    }
                    onChange={(e) => {
                      const zoneId = Number(e.target.value);
                      setSelectedZone(zoneId);
                      handleInputChange({ target: { name: "zone", value: zoneId } });
                       if (!isQualityLeadLoggedIn && !isTrainerLoggedIn) {
                      setSelectedQaLead(null);
                    }
                    }}
                    required
                  >
                    <option value="" disabled>Select Zone</option>
                    {zones.map(zone => (
                      <option key={zone.id} value={zone.id}>
                        {zone.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {/* Step 4: QA Lead Selection (only for QA role) */}
              {ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole) && selectedZone && (
                <div className="col-md-12 mb-3">
                  <label>
                    Select Lead<span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={selectedQaLead || ""}
                    disabled={
                       (isQualityLeadLoggedIn || isTrainerLoggedIn)  &&
                      ROLES_WITH_ZONE_AND_LEAD.includes(selectedRole)
                    }

                    onChange={(e) => {
                      const leadId = Number(e.target.value);
                      setSelectedQaLead(leadId);
                      handleInputChange({ target: { name: "qa_lead_id", value: leadId } });
                    }}
                    required
                  >
                    <option value="" disabled>Select Lead</option>
                  {tempQaLeads
                .filter(lead => {
                  const match = Number(lead.zone) === Number(selectedZone);
                  return match;
                })
                .map(lead => {
                  return (
                    <option key={lead.userId} value={lead.userId}>
                      {lead.fname} {lead.lname || ''}
                    </option>
                  );
                })}
                  </select>
                </div>
              )}
            {isReadyForUserForm && (
              <>
            <div className="col-md-6">
              <label className="">
                First name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="Enter your first name"
                required
                style={{ fontSize: "14px" }}
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Last name<span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Enter your last name"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Email address<span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="">
                User name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                placeholder="Enter your user name"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Phone<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    // only digits allowed
                    handleInputChange(e);
                  }
                }}
                placeholder="Enter your phone number"
                pattern="^[0-9]{10,13}$"
                title="Please enter a valid 10 to 13 digit phone number"
                required
                maxLength={13}
              />
            </div>
            <div className="col-md-6">
              <label className="">
                Enter password<span className="text-danger">*</span>
              </label>
              <Input.Password
                className="form-control"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="Enter password"
                pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                title="Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one number, and one special character."
                required
              />
            </div>
            {!isTraineeSelected && (
            <>
            <div className="col-md-6">
              <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  name="write_permission"
                  checked={formData.write_permission}
                  onChange={handleInputChange}
                  style={{ width: "24px", height: "24px", marginRight: "8px", cursor: "pointer" }}
                />
                Write Permission
              </label>
            </div>

            <div className="col-md-6">
              <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                <input
                  type="checkbox"
                  name="read_permission"
                  checked={formData.read_permission}
                  onChange={handleInputChange}
                  style={{ width: "24px", height: "24px", marginRight: "8px", cursor: "pointer" }}
                />
                Read Permission
              </label>
            </div>
            </>
            )}
                {/* Batch Number & Joining Date - Only for Trainee */}
            {isTraineeSelected && (
              <>
                <div className="col-md-6">
                  <label>
                    Batch Number<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="batch_number"
                    value={formData.batch_number || ""}
                    onChange={handleInputChange}
                    placeholder="Enter Batch Number"
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label>
                    Joining Date<span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="joining_date"
                    value={formData.joining_date || ""}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </>
            )}


            {/* Status section only shown in Edit mode */}
            {isEdit && (
              <div className="d-flex flex-column mt-3">
                <label>Status</label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <Button
                    key="active"
                    onClick={() => handleStatusChange("active")}
                    style={{
                      flex: 1,
                      background: formData.status === "active" ? "#00C853" : "transparent",
                      color: formData.status === "active" ? "#FFFFFF" : "#000000",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    Active
                  </Button>
                  <Button
                    key="inactive"
                    onClick={() => handleStatusChange("inactive")}
                    style={{
                      flex: 1,
                      background: formData.status === "inactive" ? "#F44336" : "transparent",
                      color: formData.status === "inactive" ? "#FFFFFF" : "#000000",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    Inactive
                  </Button>
                </div>
              </div>
            )}

            <div style={{ display: "flex", gap: "8px", marginTop: "50px" }}>
              <Button
                key="cancel"
                onClick={handleCancel}
                style={{
                  flex: 1,
                  background: "#FFEBEE",
                  color: "#F44336",
                  border: "none",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
              >
                Cancel
              </Button>
              <Button
                key="confirm"
                style={{
                  flex: 1,
                  background: "#052659",
                  color: "#FFFFFF",
                  border: "none",
                  paddingTop: "20px",
                  paddingBottom: "20px",
                }}
                htmlType="submit"
              >
                {isEdit ? "Save changes" : "Confirm"}
              </Button>
            </div>
          </>
)}
          </form>
        </div>
      </Modal>
    </>
  );
};

export default QAModel;
